import serviceBase from '../../../Services/serviceBase'

class MenuSectionActions {
  getCustomSections = async (identifier) => {
    let url = `${window._env_.COMMUNITY_API_URL
      }/custom-sections/urls/${identifier}`
    return serviceBase.get(url).then(
      (response) => {
        if (response && response.data) {
          let csArray = []
          if (Array.isArray(response.data)) {
            response.data.forEach((element, index) => {
              csArray.push({
                title: element.title,
                order: element.order ? element.order : index,
                id: element._id,
                isAdded: "false",
                onlyPreview: Boolean(element.onlyPreview)
              })
            })
            return csArray
          }
          else {
            return []
          }
        }
      },
      (err) => { }
    )
  }

  deleteCustomSections = async (customSectionId) => {
    let url = `${window._env_.COMMUNITY_API_URL
      }/custom-sections?id=${customSectionId}`
    if (customSectionId) {
      return serviceBase.delete(url).then(
        (response) => {
          if (response.status === 200) {
            return true
          }
          else {
            return false
          }
        },
        (err) => {
          console.log('deleteCustomSections => ', err)
        }
      )
    } else {
      return false
    }
  }

  customSectionReorderPost = async (customSections) => {
    let url = `${window._env_.COMMUNITY_API_URL
      }/custom-sections/order`
    return serviceBase.post(url, customSections).then(
      (response) => {
        if (response.status === 200) {
          return true
        }
        else {
          return false
        }
      },
      (err) => { }
    )
  }

  getMenuSettings = async (identifier) => {
    let url = `${window._env_.COMMUNITY_API_URL
      }/menu-settings/${identifier}`
    return serviceBase.get(url).then(
      (response) => {
        if (response && response.data.data) {
          let menuSettings = {}
          if (response.data.data.hasOwnProperty('gallery') && response.data.data.hasOwnProperty('donate')) {
            menuSettings = {
              gallery: response.data.data.gallery.name,
              donate: response.data.data.donate.name
            }
          } 
          return menuSettings
        }
      },
      (err) => { }
    )
  }

  getMarketingSectionsByDepartment = async (fireDepartment) => {

    let url = `${window._env_.COMMUNITY_API_URL
    }/marketing-custom-section/by-logged-emergency-provider/${fireDepartment.identifier}`

    return serviceBase.get(url).then(

      (response) => {

        if(response && response.data) {

          // Process results here
          return [{id: response.data._id, title: response.data.title}]

        } 
      }
    )
  }
}

export default new MenuSectionActions()
